/**
 * Flatten a nested object into dotted HTTP query params.
 * Kept in its own module so consumers (e.g. admin-web via sdk) can import
 * without pulling in `@care-portals/data` through the utils barrel.
 */
export const convertToHttpParams = (obj: any) => {
  const params: { [key: string]: string } = {};

  const flattenObject = (data: any, parentKey: string = ''): void => {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const value = data[key];
        const newKey = parentKey ? `${parentKey}.${key}` : key;

        if (value !== null && value !== undefined) {
          if (typeof value === 'object' && !Array.isArray(value)) {
            flattenObject(value, newKey);
          } else if (typeof value === 'string') {
            if (value.trim().length > 0) {
              params[newKey] = value; // no need to trim here to search for spaces
            }
          } else {
            params[newKey] = value.toString();
          }
        }
      }
    }
  };

  flattenObject(obj);
  return params;
};
